import { IComponentNode } from 'app/app/editor/index.functions';
import { Box } from '@mui/material';
import NodeNameLine from 'app/app/editor/tabs/elements/layout/NodeNameLine';

export default function FlatList({ node }: { node: IComponentNode }) {
    const getNodes = (node: IComponentNode): Array<IComponentNode> => {
        return node.type == 'container'
            ? (node.elements?.map((n) => getNodes(n)).reduce((a, b) => a.concat(b), []) ?? [])
            : [node];
    };
    const nodeList: Array<IComponentNode> = getNodes(node);

    return (
        <Box>
            {nodeList.map((node) => (
                <NodeNameLine key={node.params.uid} node={node} />
            ))}
        </Box>
    );
}
